import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import AudioTest from "../audioVisualizer";
import { imageURl } from "../../libs/env";
import { Row } from "reactstrap";
import { SpeakerTest } from "../speakerTest/SpeakerTest";
import { NetWorkSpeedTest } from "../networkSpeedTest/NetWorkSpeedTest";

const VisualizerModel = ({ isOpen, toggle }) => {
  return (
    <Modal
      isOpen={isOpen}
      size="lg"
      toggle={toggle}
      className="modal-dialog-centered"
      backdrop="static"
    >
      <ModalBody className="p-0">
        <Row>
          <div className="text-end">
            <button onClick={toggle} className="btn p-0 me-2 ">
              <img src={`${imageURl}/close.png`} width="17px" alt="Cross img" />
            </button>
          </div>

          <p className="text-center mb-4 d-inline">
            <b>Check your microphone, speaker and bandwidth</b>
          </p>
        </Row>
        <AudioTest />
        <SpeakerTest />
        <NetWorkSpeedTest />
      </ModalBody>
    </Modal>
  );
};

VisualizerModel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

VisualizerModel.defaultProps = { isOpen: false };

export default VisualizerModel;
